import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../pages/PageHeader';
const TermAndCondition = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // This will move the user to the top of the page
      }, []);
      
  return (
    <div>
           <Helmet>
  {/* Title */}
  <title>Terms and Conditions | AppNexts</title>

  {/* Meta Description */}
  <meta
    name="description"
    content="Read the Terms and Conditions for using the AppNexts website and services. Understand your rights and responsibilities when interacting with our digital solutions."
  />

  {/* Meta Keywords */}
  <meta
    name="keywords"
    content="terms and conditions, legal terms, privacy policy, user agreement, appnexts terms, website policy, appnexts legal"
  />

  {/* Canonical URL */}
  <link rel="canonical" href="https://www.appnexts.com/terms-and-conditions" />

  {/* Open Graph */}
  <meta property="og:title" content="Terms and Conditions | AppNexts" />
  <meta
    property="og:description"
    content="Read the official Terms and Conditions for using AppNexts services and digital platforms."
  />
  <meta property="og:image" content="https://www.appnexts.com/seo_image/Terms_and_Conditions_seo.png" />
  <meta property="og:url" content="https://www.appnexts.com/terms-and-conditions" />
  <meta property="og:type" content="website" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Terms and Conditions | AppNexts" />
  <meta
    name="twitter:description"
    content="Stay informed about AppNexts' terms of service and legal responsibilities when using our solutions."
  />
  <meta name="twitter:image" content="https://www.appnexts.com/seo_image/Terms_and_Conditions_seo.png" />

  {/* Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Terms and Conditions",
      "url": "https://www.appnexts.com/terms-and-conditions",
      "description": "Terms and Conditions for using AppNexts services and digital platforms.",
      "publisher": {
        "@type": "Organization",
        "name": "AppNexts",
        "url": "https://www.appnexts.com"
      },
      "mainEntity": {
        "@type": "CreativeWork",
        "name": "Terms and Conditions",
        "inLanguage": "en"
      }
    })}
  </script>
</Helmet>

      <PageHeader title="Terms and Conditions" breadcrumb={[{ label: "Home", path: "/" },{ label: "Terms and Conditions" }]}/>

<div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
Terms and Conditions
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        Please read these terms and conditions carefully before using our website or software development services. By using our website or software development services, you agree to these terms and conditions.
        </p>
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Use of Website and Services:
        </h1>
        <p className="font-medium mt-3">
        AppNexts provides software development services to clients worldwide. Our website and services are intended for individuals and businesses who are interested in our software development services.
        </p>
    </div>

    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Intellectual Property:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        All content on our website, including but not limited to text, graphics, logos, images, and software, is the property of AppNexts or our content suppliers and is protected by copyright laws. You may not copy, distribute, or use any content on our website without our prior written consent.
        </p>
        <p className="text-[15px] font-medium mb-8 mt-3">
        Our software development services are also protected by copyright laws. We retain all intellectual property rights in our software development services, including but not limited to source code, database designs, and user interfaces. You may not modify, reproduce, or distribute our software development services without our prior written consent.
        </p>
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Disclaimer of Warranties:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        Our software development services are provided “as is” and without warranties of any kind, whether express or implied. We do not warrant that our software development services will be error-free, uninterrupted, or free from viruses or other harmful components. We disclaim all warranties, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Limitation of Liability:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        In no event shall AppNexts be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with our website or software development services, including but not limited to lost profits, loss of data, or interruption of business. Our total liability to you shall not exceed the amount paid by you for our software development services.
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Indemnification:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
      
You agree to indemnify, defend, and hold harmless AppNexts and its officers, directors, employees, and agents from and against any claims, damages, costs, and expenses, including but not limited to attorney fees, arising out of or in connection with your use of our website or software development services.
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Governing Law:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        These terms and conditions shall be governed by and construed in accordance with the laws of Pakistan, without giving effect to any principles of conflicts of law.
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Updates to Terms and Conditions:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        We may update these terms and conditions from time to time. We will notify you of any changes by posting the updated terms and conditions on our website. We encourage you to review these terms and conditions periodically.
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4  sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Contact Us:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        If you have any questions or concerns about our privacy policy, please contact us at
        <Link to="mailto:info@appnexts.com" className='text-[#504e9a] font-semibold mx-1'>info@appnexts.com</Link> We’re happy to answer any questions you may have and ensure that your personal information is protected.
        </p>
       
    </div>
    </div>
    </div>
  );
};

export default TermAndCondition;
